import React from "react";
import { useSelector } from "react-redux";
import TextInput from "../../../../ui/textInput/TextInput";

const MAX_NAME_LENGTH = 20;

const NameField = ({ value, onChange }) => {
    const { texts } = useSelector((state) => state.translate);

    return (
        <TextInput
            label={texts.toolName}
            value={value}
            onChange={onChange}
            placeholder={texts.toolNamePlaceholder}
            maxLength={MAX_NAME_LENGTH}
            showCharCounter
            charCounterSuffix={texts.chars}
        />
    );
};

export default NameField;
